const DEFAULT_DOMAIN = '/api/v2'
const DEFAULT_LOGIN_PATH = '/auth/google'

function getAppConfig() {
    if (typeof window === 'undefined' || !window.__APP_CONFIG__) {
        return {}
    }

    return window.__APP_CONFIG__
}

function getConfigValue(key, fallbackValue, { allowEmpty = false } = {}) {
    const configValue = getAppConfig()[key]

    if (typeof configValue !== 'string') {
        return fallbackValue
    }

    if (allowEmpty || configValue.length > 0) {
        return configValue
    }

    return fallbackValue
}

export function getAppDomain() {
    return getConfigValue('VUE_APP_DOMAIN', DEFAULT_DOMAIN, { allowEmpty: true })
}

export function getLoginPath() {
    return getConfigValue('VUE_APP_LOGIN_PATH', DEFAULT_LOGIN_PATH)
}

export function getAppUrl(path) {
    const normalizedDomain = getAppDomain().replace(/\/$/, '')
    const normalizedPath = path.startsWith('/') ? path : `/${path}`

    return `${normalizedDomain}${normalizedPath}`
}